import { getDatenqualitaet } from '../getDatenqualitaet';

export function processSubscopeDatenqualitaet(row: any, entity: string, subscope: number, part: number) {
    let sum_datenherkunft = 0;
    let sum_datenqualitaet = 0;
    let sum_bewertung = 0;
    let count_datenherkunft = 0;
    let count_datenqualitaet = 0;
    let count_bewertung = 0;

    if (subscope === 13) {
        if (+part === 1) {
                row['datenqualitaet_emissionsfaktor'] = 3;
                row['bewertung_emissionsfaktor'] = 3;
        } else  {
                row['datenqualitaet_emissionsfaktor'] = 1;
                row['bewertung_emissionsfaktor'] = 1;
        }
    }

    Object.keys((row || {})).forEach((key: string) => {
        if (key === 'datenherkunft' && +row[key] > 0) {
            count_datenherkunft++;
            sum_datenherkunft += +row[key];
        }

        if (key === 'datenqualitaet_emissionsfaktor' && +row[key] > 0) {
            count_datenqualitaet++;
            sum_datenqualitaet += +row[key];
        }

        if (key === 'bewertung_emissionsfaktor' && +row[key] > 0) {
            count_bewertung++;
            sum_bewertung += +row[key];
        }
    });
    const arr =   [{
        wert: 1,
        datenherkunft: count_datenherkunft > 0 ? sum_datenherkunft / count_datenherkunft : 0,
        bewertung: count_bewertung > 0 ? sum_bewertung / count_bewertung : 0,
        emissionsfaktor: count_datenqualitaet > 0 ? sum_datenqualitaet / count_datenqualitaet : 3
    }];
    row.datenqualitaet = getDatenqualitaet(arr);
    // console.log('processSubscopeDatenqualitaet', entity, row.name, row.datenqualitaet, arr, row);
}